<div class="w-full flex flex-col gap-2">
    <!-- Add task button or form -->
    @if (!showCreateForm) {
        <p-button
            [buttonProps]="{ autofocus: false }"
            label="Add task..."
            icon="pi pi-plus"
            (click)="onToggleCreateForm()"
            severity="secondary"
            [outlined]="true"
            size="small"
            [disabled]="!canAddMoreTasks"
            styleClass="w-full !justify-start"
            [pTooltip]="!canAddMoreTasks ? 'Maximum of 20 tasks allowed' : ''"
            tooltipPosition="top">
        </p-button>
    } @else {
        <fm-task-form
            mode="create"
            [autoFocusTitle]="true"
            [taskTitle]="newTaskTitle"
            [taskDescription]="newTaskDescription"
            [hideAttachmentAction]="true"
            submitButtonLabel="Create task"
            [submitButtonDisabled]="!newTaskTitle.trim()"
            (titleChange)="newTaskTitle = $event"
            (descriptionChange)="newTaskDescription = $event"
            (submit)="onCreateTask()"
            (cancel)="cancelCreate()">
        </fm-task-form>
    }

    <!-- Task list -->
    @if (tasks.length > 0) {
        <div class="flex flex-col gap-1.5">
            @for (task of tasks; track $index) {
                @if (editingIndex === $index) {
                    <fm-task-form
                        mode="edit"
                        [autoFocusTitle]="true"
                        [taskTitle]="editingTaskTitle"
                        [taskDescription]="editingTaskDescription"
                        [hideAttachmentAction]="true"
                        submitButtonLabel="Save"
                        [submitButtonDisabled]="!editingTaskTitle.trim()"
                        (titleChange)="editingTaskTitle = $event"
                        (descriptionChange)="editingTaskDescription = $event"
                        (submit)="onSaveEdit()"
                        (cancel)="cancelEdit()"
                        (overflowDelete)="onOverflowDeleteWhileEditing()">
                    </fm-task-form>
                } @else {
                    <fm-task-item
                        [task]="queuedTaskToUserTask(task, $index)"
                        [taskIndex]="$index"
                        [isEditing]="false"
                        [showSessionInfo]="false"
                        [hideAttachmentAction]="true"
                        [groupedSessions]="[]"
                        (taskClick)="onTaskClick($event)"
                        (checkboxChange)="onCheckboxChange($event)"
                        (deleteTask)="onDeleteTaskFromItem($event)">
                    </fm-task-item>
                }
            }
        </div>
    }
</div>
